import {
  BannerInfo,
  RoleType,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { Tea } from '@features/libs/tea';
import { Collector } from '@dp/byted-tea-sdk-oversea';

const PEARL_APP_ID = 5969;
const pearlTracker = new Collector('pearlTracker');
const { channel, channel_domain, channel_type } =
  (window.__SELLER_APP_ENVS__?.tea as any) || {};
pearlTracker.init({
  app_id: PEARL_APP_ID,
  channel: channel as any,
  channel_domain: channel_domain as any,
  channel_type: channel_type as any,
});
pearlTracker.start();

export const BannerReport = {
  show: (info: BannerInfo, userId: string, roleType: RoleType) => {
    Tea('page_show', {
      page_name: 'seller_university_homepage',
      type: 'module',
      module_name: 'homepage_banner',
      content: info.jump_url,
      sequence_id: info.slide,
    });
    pearlTracker.event('placement_show', {
      page_name: 'seller_university_homepage',
      module_name: 'homepage_banner',
      ec_account_id: userId,
      role_type: roleType,
      placement_id: info.category_id,
      campaign_id: info.campaign_id,
      sequence_id: info.slide,
    });
  },
  click: (info: BannerInfo, userId: string, roleType: RoleType) => {
    Tea('button_click', {
      page_name: 'seller_university_homepage',
      module_name: 'homepage_banner',
      click_for: 'banner',
      content: info.jump_url,
    });
    pearlTracker.event('placement_click', {
      page_name: 'seller_university_homepage',
      module_name: 'homepage_banner',
      ec_account_id: userId,
      role_type: roleType,
      placement_id: info.category_id,
      campaign_id: info.campaign_id,
      sequence_id: info.slide,
    });
  },
};
